import React from 'react'
import { IconButton } from '@material-ui/core'
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined'
import { H2 } from '../../components'

export interface IRequestHeader {
  index: number
  count: number
  removeRequest: (index: number) => void
  isFormDisabled?: boolean
}

export const RequestHeader = ({
  index,
  count,
  removeRequest,
  isFormDisabled = false,
}: IRequestHeader) => (
  <H2>
    Request {index + 1} of {count}{' '}
    <IconButton onClick={() => removeRequest(index)} disabled={isFormDisabled}>
      <DeleteForeverOutlinedIcon
        color={isFormDisabled ? 'disabled' : 'primary'}
      />
    </IconButton>
  </H2>
)
